import { useOAuth } from '@novafuturltd/core'
import { permissionValidation } from '@novafuturltd/shared'
import { CACHE_PURGE_PERMISSION } from '../constants/purgeTargets'
import { getCachePurgeWebsite } from '../constants/purgeWebsites'

export const useCanPurgeCache = () => {
  const { organizationId, permissions } = useOAuth()

  return (
    !!getCachePurgeWebsite(organizationId) &&
    permissionValidation(permissions, CACHE_PURGE_PERMISSION)
  )
}
